/* Robbel3D – Chat-Button weicht unteren Leisten aus (Webstra, Oktober 2026)
   Misst schwebende Leisten am unteren Rand (Kaufleiste, Berater-Warenkorb, mobile Leisten)
   und schiebt den Shopify-Chat-Button per CSS-Variable --r3d-chat-lift darüber. */
(() => {
  const root = document.documentElement;
  const GAP = 12;
  const BARS = [
    'product-sticky-form .product-sticky-form__card',
    '.pa-buybar',
    '.mobile-dock',
    '[data-r3d-bottom-bar]'
  ].join(',');
  let lift = 0;
  let frame = 0;

  const chatButton = () => document.querySelector('shopify-chat')?.shadowRoot
    ?.querySelector('shopify-agent-runtime')?.shadowRoot?.querySelector('[part="activator"]');

  const measure = () => {
    frame = 0;
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    const button = chatButton();
    const buttonRect = button?.getBoundingClientRect();
    // Position ohne die aktuelle (ggf. gerade animierte) Verschiebung
    let shift = 0;
    try { shift = new DOMMatrixReadOnly(getComputedStyle(button).transform).m42; } catch (error) { shift = 0; }
    const buttonBottom = buttonRect && buttonRect.height ? buttonRect.bottom - shift : vh - 20;
    const buttonLeft = buttonRect && buttonRect.width ? buttonRect.left : vw - 130;
    const buttonRight = buttonRect && buttonRect.width ? buttonRect.right : vw - 20;

    let needed = 0;
    document.querySelectorAll(BARS).forEach(bar => {
      const rect = bar.getBoundingClientRect();
      if (!rect.width || !rect.height || rect.top >= vh) return;
      const style = getComputedStyle(bar);
      if (style.visibility === 'hidden' || Number(style.opacity) < 0.1) return;
      if (rect.bottom < vh - 60) return; // liegt nicht am unteren Rand
      if (rect.right <= buttonLeft || rect.left >= buttonRight) return; // kein horizontaler Überlapp
      needed = Math.max(needed, buttonBottom - (rect.top - GAP));
    });

    const next = Math.max(0, Math.round(needed));
    if (next !== lift) {
      lift = next;
      root.style.setProperty('--r3d-chat-lift', `${lift}px`);
    }
  };

  const schedule = () => { if (!frame) frame = requestAnimationFrame(measure); };
  // Leisten blenden sich animiert ein – deshalb nach dem Scrollen mehrfach nachmessen
  const settle = () => { schedule(); [350, 800, 1500].forEach(delay => window.setTimeout(schedule, delay)); };

  window.addEventListener('scroll', settle, { passive: true });
  window.addEventListener('resize', schedule);
  document.addEventListener('transitionend', schedule, true);
  document.addEventListener('animationend', schedule, true);
  document.addEventListener('DOMContentLoaded', settle);
  window.addEventListener('load', settle);
  new MutationObserver(schedule).observe(document.documentElement, {
    subtree: true, childList: true, attributes: true, attributeFilter: ['style', 'class', 'hidden']
  });
  settle();
})();
